import React from 'react';
import { Navigate, Route, Routes, Outlet } from 'react-router-dom';
import { isEnterprise, isCustom } from '@prerender/billing-shared';

import BillingHistory from './history/BillingHistory';
import BillingPayment from './payment/BillingPayment';
import requireAuth from '../../components/hocs/requireAuth';
import BillingPlans from './plans/BillingPlans';
import CancelPlan from './plans/CancelPlan';
import BillingOverview from './overview/BillingOverview';
import { usePrerenderUser } from '../../hooks/usePrerenderUser';
import ReferralOverview from './referral/ReferralOverview';
import BillingLayout from './BillingLayout';
import BILLING_PAGES from './availablePages';

function BillingRoutes() {
  const user = usePrerenderUser();

  const isEnterpriseUser = isEnterprise(user?.chargebeePlanId);
  // TODO: remove "customPrice" check once user have migrated to new 2025 pricing plans
  const isCustomPlanUser = typeof user.customPrice === 'number' || isCustom(user?.chargebeePlanId);

  return (
    <Routes>
      <Route path="" element={<BillingLayout />}>
        {/* redirect from /billing to /billing/overview */}
        {/* Relative is safe here: the index route only matches when the splat is empty. */}
        <Route path="" index element={<Navigate to="overview" />} />
        <Route path={BILLING_PAGES.overview} element={<BillingOverview />} />
        {!isCustomPlanUser && (
          <Route path={BILLING_PAGES.plans} element={<Outlet />}>
            <Route index element={<BillingPlans />} />
            <Route path={BILLING_PAGES.cancelPlan} element={<CancelPlan />} />
          </Route>
        )}
        <Route path={BILLING_PAGES.packages} element={<Navigate to="/billing/overview" replace />} />
        <Route path={BILLING_PAGES.history} element={<BillingHistory />} />
        <Route path={BILLING_PAGES.payment} element={<BillingPayment />} />
        {!isEnterpriseUser && <Route path={BILLING_PAGES.referral} element={<ReferralOverview />} />}

        {/* redirect from /billing/anything to /billing/overview. Absolute target: a relative
            `to` in a splat catch-all resolves against the full splat match in react-router 7
            and would redirect onto itself forever. */}
        <Route path="*" element={<Navigate to="/billing/overview" replace />} />
      </Route>
    </Routes>
  );
}

export default requireAuth(BillingRoutes);
